import React from "react";
import { Box, Grid } from "@mui/material";
import { AppLayout } from "layout";
import {

    ReceiptData,
} from "modules/PaymentManagement/components";

type Props = {};

const ReceiptContainer = (props: Props) => {

    return (

        <Box>
            <ReceiptData />

        </Box>


    );
};

export default ReceiptContainer;
